// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"224":"0f405313","227":"06581ac3","335":"6a0ed46e","671":"25e7e2d1","816":"048b236a"}[chunkId] + ".js";
};